//  Decode HTML
export const decodeHtml = (html) => {
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
};

//  Clean + Fix HTML
export const cleanHtml = (html = "", basePath = "") =>
  decodeHtml(
    html
      .replace(/<!\[CDATA\[/gi, "")
      .replace(/\]\]>/g, "")
      .replace(/dir=ltr/gi, 'dir="ltr"')

      // ✅ Fix images
      // .replace(/<img([^>]*?)src="(?!http)(.*?)"/gi, (match, pre, src) => {
      //   return `<img${pre}src="${basePath}${src}"`;
      // })
      .replace(/<(img|IMG)([^>]*?)src="(?!http)(.*?)"/gi, (match, tag, pre, src) => {
  return `<img${pre}src="${basePath}${src}"`;
})

      // remove empty p
      .replace(/<p>(\s|&nbsp;|<br\s*\/?>)*<\/p>/gi, "")

      .trim()
  );

//  Node extractor
export const getNodeValue = (node, basePath) => {
  if (!node) return "";

  if (node.children.length > 0) {
    return cleanHtml(node.innerHTML, basePath).trim();
  }

return cleanHtml((node.textContent || "").trim(), basePath);
};

//  Universal parser
export const parseXML = (xmlDoc, type, basePath) => {
  if (!xmlDoc) return null;

  switch (type) {
    case "ti":
    case "ts":
    case "afl":
      return parseStandard(xmlDoc, type, basePath);

    case "rap":
      return parseRAP(xmlDoc, basePath);

    case "cm":
      return parseCM(xmlDoc, basePath);

    case "wks":
      return parseWorksheet(xmlDoc, basePath);

    default:
      return null;
  }
};

//  STANDARD (TI, TS, AFL)
// const parseStandard = (xmlDoc, type, basePath) => {
//   const fieldsMap = {
//     ti: ["Objective", "ImplementationTime", "MaterialsRequired", "PrerequisitSkills", "Procedures", "StudentResources", "Image"],
//     ts: ["Text", "File"],
//     afl: ["AFLTechniques", "Objectives", "ImplementationTime", "ResourcesRequired", "DetailedInstruction", "Assessments", "Image"],
//   };

//   const fields = fieldsMap[type] || [];

//   return fields
//     .map((tag) => {
//       const node = xmlDoc.querySelector(tag);
//       return {
//         label: tag,
//         type: tag.toLowerCase().includes("image") || tag === "File" ? "image" : "html",
//         value:
//           tag === "File"
//             ? xmlDoc.querySelector("File")?.textContent || ""
//             : getNodeValue(node, basePath),
//       };
//     })
//     .filter((f) => f.value);
// };

const parseStandard = (xmlDoc, type, basePath) => {
  const fieldsMap = {
    ti: [
      "Objective",
      "ImplementationTime",
      "MaterialsRequired",
      "PrerequisitSkills",
      "Procedures",
      "StudentResources",
      "Image",
    ],
    ts: ["Text", "Image"],
    afl: [
      "AFLTechniques",
      "Objectives",
      "ImplementationTime",
      "ResourcesRequired",
      "DetailedInstruction",
      "Assessments",
      "Image",
    ],
  };

  const fields = fieldsMap[type] || [];

  const content = fields
    .map((tag) => {
      const node = xmlDoc.querySelector(tag);

      return {
        tag,
        value:
          tag === "File" || tag === "Image"
            ? node?.textContent?.trim()
            : getNodeValue(node, basePath),
      };
    })
    .filter((f) => f.value);

  return {
    title:
      xmlDoc.querySelector("Header Type")?.textContent ||
      type.toUpperCase(),
    content,
  };
};

// 🔥 RAP
const parseRAP = (xmlDoc, basePath) => {
  const header = getNodeValue(xmlDoc.querySelector("HeaderText"), basePath);

  const examples = [...xmlDoc.querySelectorAll("Example")]
    .map((ex) => ({
      text: getNodeValue(ex.querySelector("Text"), basePath),
      image: ex.querySelector("LocalFile")?.textContent?.trim() || "",
    }))
    .filter((e) => e.text || e.image);

  return { header, examples };
};

// 🔥 CM (Graphic Organizer)
const parseCM = (xmlDoc, basePath) => {
  const file =
    xmlDoc.querySelector("File")?.textContent ||
    xmlDoc.querySelector("Image")?.textContent ||
    "";

  return {
    image: file ? `${basePath}${file.trim()}` : "",
  };
};

const parseWorksheet = (xmlDoc, basePath) => {
  const result = {
    labelDiagrams: [],
    fillBlanks: [],
    matchFollowing: [],
    trueFalse: [],
    shortAnswers: [],
    pictureComprehension: [],
    mcq: [],
  };

  // =========================
  // Label Diagram
  // =========================
  xmlDoc.querySelectorAll("LabelTheDiagram").forEach((item) => {
    if (item.getAttribute("HasValue") !== "Y") return;

    result.labelDiagrams.push({
      image: item.querySelector("Image")?.textContent?.trim(),
      description: getNodeValue(item.querySelector("Description"), basePath),
    });
  });

  // =========================
  // Fill in blanks
  // =========================
  xmlDoc.querySelectorAll("FillintheBlanksQA Question").forEach((q) => {
    if (q.getAttribute("HasValue") !== "Y") return;

    result.fillBlanks.push({
      question: getNodeValue(q.querySelector("QText"), basePath),
      answer: getNodeValue(q.querySelector("Ans"), basePath),
    });
  });

  // =========================
  // Match Following
  // =========================
  const matchQuestions = xmlDoc.querySelectorAll(
    "MatchTheFollowing Questions Question"
  );
  const matchAnswers = xmlDoc.querySelectorAll(
    "MatchTheFollowing Answers Ans"
  );

  if (matchQuestions.length > 0) {
    const left = [];
    const right = [];
    const answers = [];

    matchQuestions.forEach((q) => {
      if (q.getAttribute("HasValue") !== "Y") return;
      left.push(getNodeValue(q.querySelector("PartA"), basePath));
      right.push(getNodeValue(q.querySelector("PartB"), basePath));
    });

    matchAnswers.forEach((a) => {
      answers.push({
        left: a.getAttribute("PartA"),
        right: a.getAttribute("PartB"),
      });
    });

    result.matchFollowing.push({ left, right, answers });
  }

  // =========================
  // True False
  // =========================
  xmlDoc.querySelectorAll("TrueFalse Question").forEach((q) => {
    if (q.getAttribute("HasValue") !== "Y") return;

    result.trueFalse.push({
      question: getNodeValue(q.querySelector("QText"), basePath),
      answer: getNodeValue(q.querySelector("Ans"), basePath),
    });
  });

  // =========================
  // Short Answers
  // =========================
  xmlDoc.querySelectorAll("ShortAnswer Question").forEach((q) => {
    if (q.getAttribute("HasValue") !== "Y") return;

    result.shortAnswers.push({
      question: getNodeValue(q.querySelector("QText"), basePath),
      answer: getNodeValue(q.querySelector("Ans"), basePath),
    });
  });

  // =========================
  // Picture Comprehension
  // =========================
  xmlDoc.querySelectorAll("PictureComprehension").forEach((pc) => {
    const image = pc.querySelector("Image")?.textContent?.trim();

    const questions = [...pc.querySelectorAll("Question")]
      .filter((q) => q.getAttribute("HasValue") === "Y")
      .map((q) => ({
        question: getNodeValue(q.querySelector("QText"), basePath),
        answer: getNodeValue(q.querySelector("Ans"), basePath),
      }));

    result.pictureComprehension.push({
      image,
      questions,
    });
  });

  // =========================
  // MCQ
  // =========================
  xmlDoc.querySelectorAll("MCQ Question").forEach((q) => {
    if (q.getAttribute("HasValue") !== "Y") return;

    result.mcq.push({
      image: q.querySelector("Image")?.textContent?.trim(),
      question: getNodeValue(q.querySelector("QText"), basePath),
      options: [
        getNodeValue(q.querySelector("AnsA"), basePath),
        getNodeValue(q.querySelector("AnsB"), basePath),
        getNodeValue(q.querySelector("AnsC"), basePath),
        getNodeValue(q.querySelector("AnsD"), basePath),
      ],
      answer: q.querySelector("CorrectAns")?.textContent?.trim(),
    });
  });

  return result;
};